@if (breadcrumbs$ | async; as breadcrumbs) {
  @if (breadcrumbs.length > 1) {
    <ds-breadcrumb [ariaLabel]="'subnav.overview' | translate">
      @for (link of breadcrumbs; track link) {
        <ds-breadcrumb-item>
          <a (click)="handleClick(link.val)" [title]="link.alt | translate" ds-link>
            {{ link.copy | translate }}
            <ds-icon [name]="'left'" class="left"></ds-icon>
          </a>
        </ds-breadcrumb-item>
      }
    </ds-breadcrumb>
  }
}
